module.exports = __webpack_public_path__ + "img/three-vertical-dots.4fc53509.svg";